"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("quark-web/styles");

var _default = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    'flex-direction': 'column',
    'align-items': 'center',
    'justify-content': 'flex-start',
    'background-color': 'rgba(55, 55, 58, .67)'
  },
  content: {
    width: 480,
    backgroundColor: 'white',
    boxShadow: _styles.boxShadow,
    borderRadius: 3,
    padding: 30,
    marginTop: 50,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column'
  }
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-web/components/overlay/Overlay/styles.js
// module id = ./node_modules/quark-web/components/overlay/Overlay/styles.js
// module chunks = 0